import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import {useOutlet} from 'reconnect.js';
import Breadcrumb from '../../Components/Breadcrumb';

function AboutChairman(props) {
  const [about] = useOutlet('about');

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>第22屆理事長的話</h2>
        <Breadcrumb third="第22屆理事長的話" />
      </div>

      <section className="top-section">
        <div className="left">
          <div className="chairman-title">
            台北市牙醫師公會理事長{' '}
            <span className="chairman-name">{about?.chairman?.name} </span> 醫師
          </div>

          <div>學歷</div>
          <ul>
            {(about?.chairman?.education || []).map((x, idx) => (
              <li key={idx}>{x}</li>
            ))}
          </ul>
          <div>經歷</div>
          <ul>
            {(about?.chairman?.work_experience || []).map((x, idx) => (
              <li key={idx}>{x}</li>
            ))}
          </ul>
        </div>
        <div className="right">
          <img
            src={about?.chairman?.avatar}
            className="avatar"
            alt="chairman-avatar"
          />
        </div>
      </section>
      <section>
        <div
          dangerouslySetInnerHTML={{
            __html: about?.chairman?.raw_html?.enabled
              ? about?.chairman?.raw_html.html
              : about?.chairman?.richtext.html,
          }}
        />
      </section>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & .avatar {
    width: 200px;
  }
  & .top-section {
    margin-bottom: 20px;
    background-color: var(--primaryLightColor);
    display: flex;
    padding: 30px;

    & > .left {
      flex: 1;
    }

    & ul {
    }
  }

  & .chairman-title {
    font-size: 20px;
    color: var(--primaryColor);
    margin-bottom: 20px;
  }
  & .chairman-name {
    font-size: 30px;
    color: #000;
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & .top-section {
      flex-direction: column-reverse;
      align-items: center;
      gap: 15px;
    }

    & .chairman-title {
      text-align: center;
    }
  }
`;

export default withPageEntry(AboutChairman);
